import { render, staticRenderFns } from "./MigRation.vue?vue&type=template&id=9233c3ec&scoped=true&"
import script from "./MigRation.vue?vue&type=script&lang=js&"
export * from "./MigRation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9233c3ec",
  null
  
)

export default component.exports